import React from 'react'
import { Theme } from '@fs/zion-ui'
import { ROOTSTECH_BRAND } from '../config'

export default function BlackText({ children, ...props }) {
  return (
    <Theme theme="complementary" brand={ROOTSTECH_BRAND} transparent {...props}>
      {children}
    </Theme>
  )
}
